/** @file isId: checks that a value is a well-formed id, optionally of one prefix. */
import { ID_PREFIXES, type IdPrefix } from './idPrefixes';

const ID = new RegExp(`^(?:${ID_PREFIXES.join('|')})_[0-9A-HJKMNP-TV-Z]{26}$`);

/** True when `value` is `<known prefix>_<26 Crockford base32 chars>` and, if given, has `prefix`. */
export function isId(value: unknown, prefix?: IdPrefix): value is string {
  if (typeof value !== 'string' || !ID.test(value)) return false;
  return prefix === undefined || value.startsWith(`${prefix}_`);
}
